// One definition of "valid phone" for every form that collects a delivery
// phone number (checkout, the account panel's Address screen).
const digitsOf = (raw) => String(raw || '').replace(/\D/g, '').slice(0, 10);

// Mirrors QuizPage's formatPhone(): (123) 456-7890 as the customer types.
export function formatPhoneInput(raw) {
  const d = digitsOf(raw);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function isValidPhone(value) {
  return digitsOf(value).length === 10;
}
